// 删除改变分页
const del = {
    delPage(total, delPage, pageSize, current) {
        let num = ((total - delPage) / pageSize).toString().split(".");
        let page = num.length > 1 ? Number(num[0]) + 1 : Number(num[0]);
        if (current < page) {
            return current;
        } else {
            return page;
        }
    },
};
export default del;
